import React, { useEffect, useCallback } from 'react'

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import SideStyle from '../style/sideStyle';
import Param from '../store/param';
import Control from '../store/control';



// Set PTB bar
const FormAlign_2 = () => {
  const SetCameraFront  = Control.Get("SetCameraFront");
  SetCameraFront()

  const style          = SideStyle();
  const align          = Param.Get("align");
  const setParam       = Param.Get("setParam");
  const debug          = Param.Get("debug");
  const textI = align.vpt_ptbI ? "(" + align.vpt_ptbI.x.toFixed(1) + "," 
                                     + align.vpt_ptbI.y.toFixed(1) + "," 
                                     + align.vpt_ptbI.z.toFixed(1) + ")" 
                               : null
  const textO = align.vpt_ptbO ? "(" + align.vpt_ptbO.x.toFixed(1) + "," 
                                     + align.vpt_ptbO.y.toFixed(1) + "," 
                                     + align.vpt_ptbO.z.toFixed(1) + ")" 
                               : null

                               
  const onClick = useCallback((n) => {
    setParam(s => {s.align.stepPTB = n});
  });
  
  function getActive(n){
    return (align.stepPTB == n) 
      ? `${style.button} ${style.buttonSelected}`
      : style.button;
  }


  return (
    <div>
      {debug && 
      <div className={style.outside2}>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={6}>
            <Typography>Outside</Typography>
            {/* <Button name="ptbO" className={getActive(0)} onClick={() => onClick(0)} >Outside</Button> */}
          </Grid>
          <Grid item xs={6}>
            <Typography>Inside</Typography>
            {/* <Button name="ptbI" className={getActive(1)} onClick={() => onClick(1)} >Inside</Button> */}
          </Grid>
        </Grid>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={6}>
            <Typography>{textO}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>{textI}</Typography>
          </Grid>
        </Grid>
      </div>}
    </div>
  );
}
export default FormAlign_2;
